import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {DeltaVolumiModel, DeltaVolumiStorageModel} from '../../../models/DeltaVolumiModel';
import * as toastr from 'toastr';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {Router} from '@angular/router';
import {ProviderModel} from '../../../models/ProviderModel';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {UsersService} from '../../users/service/users.service';
import {DeltaVolumiService} from '../delta-volumi/service-delta-volumi/delta-volumi.service';
import { debounceTime, delay, tap } from 'rxjs/operators';

@Component({
  selector: 'app-delta-volumes-compare',
  templateUrl: './delta-volumes-compare.component.html',
  styleUrls: ['./delta-volumes-compare.component.scss']
})
export class DeltaVolumesCompareComponent extends BaseGeneralComponent implements OnInit, OnChanges, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: DeltaVolumiModel[];
  isDeltaSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  updateAllPlains: Subscription;

  offset: Offset;
  filter: DeltaVolumiModel;
  numAnnoMeseData: any;
  contractTypeData: any;
  numAnnoMese: any;

  listRowSelected: Array<any>;
  enableUpdatePlains: boolean;
  showFilter = true;

  providerSelected: ProviderModel;

  @Input() reportSection?: boolean;
  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(private deltaVolumiService: DeltaVolumiService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private userService: UsersService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.sectionId = this.SECTIONS.MONTHLY_ACTUALS;
    this.user = JSON.parse(sessionStorage.getItem('user'));
  }

  ngOnInit() {
    this.loaderService.display(true);
    this.isDeltaSection = this.returnIsContractSection(this.router.url);
    this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;


    if (this.providerSelected.description === this.PROVIDER_IBM) {
      this.displayedColumns = ['Status', 'NumAnnoRif', 'IsClaims', 'IsRecovery', 'regionDesc',
        'localCustomerDesc', 'contractTypeDesc',
        'resourceUnitName', 'resourceUnitCod', 'designServices',
        'units', 'applicationCod', 'shareName', 'delta', 'preliminaryDelta', 'actualMonthVol',
        'previusMonthVol'];
    } else if (this.providerSelected.description.includes(this.PROVIDER_KYN)) {
      this.displayedColumns = ['Status', 'NumAnnoRif', 'IsClaims', 'IsRecovery', 'regionDesc',
      'localCustomerDesc', 'location',
      'resourceUnitName', 'resourceUnitCod', 'designServices',
      'units', 'applicationCod', 'shareName', 'delta', 'preliminaryDelta', 'actualMonthVol',
      'previusMonthVol'];
    }else if (this.providerSelected.description === this.PROVIDER_DXC) {
      this.displayedColumns = ['Status', 'NumAnnoRif', 'IsClaims', 'IsRecovery', 'regionDesc',
        'localCustomerDesc', 'contractTypeDesc',
        'resourceUnitName', 'resourceUnitCod', 'designServices',
        'units', 'deltaDxc', 'preliminaryDeltaDxc', 'actualMonthVol',
        'forecastVolumeDxc'];
    } else {
      this.displayedColumns = [];
    }


    this.selectedRowIndex = -1;
    this.listRowSelected = [];
    this.enableUpdatePlains = false;

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.DELTA_VOLUMI_OFFSET);
    this.getSessionStorageFilter();
    this.setDefaultOrderField();
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.init();
  }

  ngOnChanges() {
  }

  init() {
    this.filter.isRecovery = false;
    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
    (resultYearMonth: any) => {
      const providerDefault = this.filter.provider;
      this.numAnnoMeseData = this.filterFromDxc(providerDefault, resultYearMonth);


      if (!this.filter.numAnnoMese) {
        this.numAnnoMeseService.getLastConsumptiveVolMonth(this.providerSelected).subscribe(
          res => {
            this.filter.numAnnoMese = res;
                        if (this.reportSection) {
              this.showFilter = true;
            } else {
              this.getDataPage(this.offset, this.filter);
            }
          }
        );
      } else {
        if (!this.reportSection) {
          // this.showFilter = false;
          this.getDataPage(this.offset, this.filter);
        } else {
          this.showFilter = true;
        }
      }          },
        error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  getDataPage(offset: Offset, filter: DeltaVolumiModel) {
    this.loaderService.display(true);
    this.getPageSubscribe = this.deltaVolumiService.getComparePage(offset, filter)
    .pipe(
      tap(() => this.loaderService.display(true)),
      debounceTime(0),
      delay(0),
      tap(() => this.loaderService.display(false)),
    ).subscribe(
        (result: any) => {
          this.dataSource = result.content;
                    this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.listData.data.forEach(value => {
            this.listRowSelected.forEach(value1 => {
              if (value.id === value1.id) {
                value.isClaims = value1.isClaims;
              }
            });
          });
                    this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = result.totalElements;
          this.loaderService.display(false);

        });
  }

  openDialog(id: number) {
    const deltaVolumiData = this.dataSource.find(data => data.id === id) as DeltaVolumiModel;
    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(deltaVolumiData.numAnnoMese)},
      {id: 'Reference Month', value: this.toCustomStringAnnoMese(deltaVolumiData.numAnnoMeseRif)},
      {id: 'Is Claims', value: this.toCustomStringIs(deltaVolumiData.isClaims)},
      {id: 'Is Recovery', value: this.toCustomStringIs(deltaVolumiData.isRecovery)},
      {id: 'Provider Cod', value: this.toCustomString(deltaVolumiData.provider.cod)},
      {id: 'Provider Description', value: this.toCustomString(deltaVolumiData.provider.description)},
      {id: 'Region Cod', value: this.toCustomString(deltaVolumiData.region.cod) },
      {id: 'Region Description', value: this.toCustomString(deltaVolumiData.region.description)},
      {id: 'Local Customer Cod', value: this.toCustomString(deltaVolumiData.localCustomer.cod)},
      {id: 'Local Customer Description', value: this.toCustomString(deltaVolumiData.localCustomer.description)},
      {id: 'Contract Type Cod', value: this.toCustomString(deltaVolumiData.contractType.cod)},
      {id: 'Contract Type Description', value: this.toCustomString(deltaVolumiData.contractType.description)},
      {id: 'Resource Unit Cod', value: this.toCustomString(deltaVolumiData.resourceUnit.cod)},
      {id: 'Resource Unit Name', value: this.toCustomString(deltaVolumiData.resourceUnit.name)},
      {id: 'SL1 Cod', value: this.toCustomString( deltaVolumiData.designServices.cod)},
      {id: 'SL1 Description', value: this.toCustomString( deltaVolumiData.designServices.description)},
      {id: 'Units Cod', value: this.toCustomString(deltaVolumiData.units ? deltaVolumiData.units.cod : null)},
      {id: 'Units Description', value: this.toCustomString(deltaVolumiData.units ? deltaVolumiData.units.description : null)},
      {id: 'Application Code', value: this.toCustomString(deltaVolumiData.applicationCod)},
      {id: 'Share Name', value: this.toCustomString(deltaVolumiData.shareName)},
      {id: 'Delta', value: this.toCustomString(deltaVolumiData.delta)},
      {id: 'Current Month Volume', value: this.toCustomString(deltaVolumiData.actualMonthVol)},
      {id: 'Previous Month Volume', value: this.toCustomString(deltaVolumiData.previusMonthVol)},
      {id: 'Expected Volume', value: this.toCustomString(deltaVolumiData.expectedVol )},
      {id: 'Notes', value:  this.toCustomString(deltaVolumiData.note)}
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  openNotes(id: number) {
    const discountData = this.dataSource.find(data => data.id === id);
    const list: GenericArray[] = [
      {id: 'Note', value: discountData.note === null ? 'N.D.' : discountData.note}
    ];
    const note = true;
    const serviceType = 'delta_volume';
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list, note, discountData, serviceType}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getDataPage(this.offset, this.filter);
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.DELTA_VOLUMI_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }
  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.filter = dataFiltered ? dataFiltered.filter : null;
    this.offset.deltaFilter = dataFiltered ? dataFiltered.deltaFilter : null;
    this.setDefaultOrderField();
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }
  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }

    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
    if (this.updateAllPlains) {
      this.updateAllPlains.unsubscribe();
    }
  }

  highlight(row) {
    this.enableUpdatePlains = true;
    row.isClaims = row.isClaims === 0 ? row.isClaims = 1 : row.isClaims = 0;
    this.listRowSelected.push(row);
    this.listData.data.forEach(value => {
      if (value.id === row.id) {
        value = this.listRowSelected.find(element => element.id === row.id);
      }
    } );
  }

  updateClaims() {
    this.updateAllPlains = this.deltaVolumiService.updateAllClaims(this.listRowSelected, this.providerSelected)
      .subscribe(
        (result: any) => {
          this.enableUpdatePlains = false;
          toastr.success('Plains updated with success', 'Success');
          this.getDataPage(this.offset, this.filter);
        }, error => {
          this.loaderService.display(false);
          toastr.error('A problem has occurred, please contact the Administrator', 'Error');
        }
      );
  }

  checkDelta(row) {
    let color: string;
    // if (row.isDeltaSignificativo === 0) {
    if (row.delta === 0) {
      color = ' #83da5b transparent';
    } else {
      color = '#e6e600 transparent';
    }

    if (row.isClaims === 1) {
      color = '#da5b5b transparent';
    } else {
      // color = '#83da5b transparent';
    }

    return color;
  }

  setDefaultOrderField() {
    if (this.offset.orderField === null || this.offset.orderField === undefined || this.offset.orderField === '') {
      this.offset.orderField = 'contractTypeDesc';
      this.offset.orderDirection = 'asc';
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

  isClaimsDisabled(row: any) {
    if (!this.canUpdate || row.isConsolidated === 1 || !row.id) {
      return true;
    }
    return false;
  }

  getSessionStorageFilter() {
    const filter_: DeltaVolumiStorageModel = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DELTA_VOLUMES_FILTER));
    if (filter_) {
      this.filter = filter_;
      if (filter_.deltaFilter) {
        this.offset.deltaFilter = filter_.deltaFilter;
      }
    } else {
      this.filter = new DeltaVolumiModel();
      // this.filter.isDeltaSignificativo = 1;
    }
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
  }
}
